import React from 'react';

const CheckboxField = ({ id, label, labelLeft, checked, onChange, name, value, explanation, register, rules }) => {

  const reg = register ? {...register(name, rules)} : {
    onChange,
    name,
    checked
  };
  const checkId = id || name;

  return (
    <div className="flex mb-3 w-full">
      {labelLeft && (
        <label className="w-1/6 text-uidarker font-medium pr-6 text-right" htmlFor={checkId}>
          {labelLeft}
        </label>
      )}
      <div className='flex flex-col w-full max-w-xs'>
        <div className='flex items-center max-w-xs'>
          <input
            type="checkbox"
            id={checkId}
            {...reg}
            value={value}
            className="mr-2"
          />
          {label && (
            <label className="flex items-center" htmlFor={checkId}>{label}</label>
          )}
        </div>
        {explanation && (
          <span className="text-brandDarkBlue text-xs text-gray-500 my-1">{explanation}</span>
        )}
      </div>
    </div>
)};

export default CheckboxField;